import Select from '../components/Select.vue';

export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      selectedItem: {
        id: "",
        name: "",
      },
    }
  },
  methods: {
    atualizar(item) {
      this.selectedItem = item;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.selectedItem.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.selectedItem.id
      });
    },
  },
}